import { checkDigitsOnly } from 'legacy/lut/helpers/validateRules/checkDigitsOnly'
import { checkMaxLength } from 'legacy/lut/helpers/validateRules/checkMaxLength'
import { checkMinLength } from 'legacy/lut/helpers/validateRules/checkMinLength'

// team level agreement
const MIN_PHONE_VALUE = 6

// by E.164 standard
const MAX_PHONE_VALUE = 12

export const checkPhone = async (value: string) => {
  return (
    (await checkDigitsOnly(value)) ||
    (await checkMaxLength(value, MAX_PHONE_VALUE)) ||
    (await checkMinLength(value, MIN_PHONE_VALUE))
  )
}
